import { render, staticRenderFns } from "./ChangeCustomer.vue?vue&type=template&id=22ef99fe&scoped=true&"
import script from "./ChangeCustomer.vue?vue&type=script&lang=js&"
export * from "./ChangeCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ef99fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ef99fe')) {
      api.createRecord('22ef99fe', component.options)
    } else {
      api.reload('22ef99fe', component.options)
    }
    module.hot.accept("./ChangeCustomer.vue?vue&type=template&id=22ef99fe&scoped=true&", function () {
      api.rerender('22ef99fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/CustomersPage/ChangeCustomer.vue"
export default component.exports